import React from 'react'
import Footer from '../components/Footer'
import { useNavigate } from 'react-router-dom';
export default function About() {
    const navigate = useNavigate();

  return (
    <div>
      <section className="bg-gradient-to-br from-[#f97316] to-red-600 text-white py-24 px-4 text-center relative overflow-hidden">
        <div className="absolute inset-0 opacity-10" style={{backgroundImage:"url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23fff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")"}}/>
        <p className="text-sm font-bold text-orange-200 uppercase tracking-widest mb-4">Who We Are</p>
        <h1 className="font-serif text-6xl mb-5">Our Story</h1>
        <p className="text-xl text-orange-100 max-w-xl mx-auto">A journey of flavors, tradition and passion that started in a family kitchen in 2020.</p>
      </section>
      <section className="max-w-6xl mx-auto px-4 py-20">
        <div className="grid md:grid-cols-2 gap-16 items-center mb-20">
          <div>
            <p className="text-sm font-bold text-[#f97316] uppercase tracking-wider mb-3">The Beginning</p>
            <h2 className="font-serif text-4xl text-gray-900 mb-5 leading-tight">From Grandmother's Kitchen to 10,000 Customers</h2>
            <p className="text-gray-500 leading-relaxed mb-4">Ganapathi Raman grew up watching his grandmother spend hours in the kitchen every Sunday, preparing an elaborate feast for the extended family. The aroma of freshly ground coconut chutney, sambar simmering on low heat, and dosa batter fermenting overnight.</p>
            <p className="text-gray-500 leading-relaxed mb-7">In 2020, with the world at a standstill, he started GamapaFoods as a small tiffin service from his apartment kitchen. Today, we serve over 10,000 customers monthly from a 3,000 sq ft kitchen with a team of 25 people — all while maintaining the same family recipe standards that started it all.</p>
            <button onClick={() => navigate("/menu")} className="bg-[#f97316] text-white font-black px-8 py-4 rounded-2xl hover:bg-orange-600 btn-press transition-colors">Order Now 🍽️</button>
          </div>
          <div className="relative">
            <img src="https://images.unsplash.com/photo-1564671165093-20688ff1fffa?w=700&q=80" alt="kitchen" className="rounded-3xl shadow-2xl w-full"/>
            <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl shadow-xl p-6 hidden md:block border border-gray-100">
              <div className="font-serif font-black text-3xl text-[#f97316]">2020</div>
              <div className="text-sm text-gray-500">Founded in Hyderabad</div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-20">
          {[["🌿","Fresh Ingredients Only","We source from 12 local farms daily. Every ingredient arrives in the morning and gets used the same day. No cold storage, no compromise."],["👨‍🍳","25+ Years Experience","Our head chef, Lakshmi, trained under Michelin-starred restaurants before dedicating her craft to authentic regional South Indian cuisine."],["⚡","Technology + Tradition","Real-time order tracking, live kitchen updates, instant payments — all powered by technology built around a grandmother's recipe book."]].map(([e,t,s]) => (
            <div key={t} className="bg-white rounded-3xl p-8 border border-gray-100 shadow-sm card-hover text-center">
              <div className="text-5xl mb-5">{e}</div>
              <h3 className="font-bold text-gray-900 mb-3 text-lg">{t}</h3>
              <p className="text-gray-400 text-sm leading-relaxed">{s}</p>
            </div>
          ))}
        </div>

        <div className="bg-[#111] rounded-3xl p-10 mb-20">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            {[["50+","Menu Dishes","and growing"],["10K+","Monthly Customers","since 2020"],["4.9★","Average Rating","from 8,000+ reviews"],["30min","Delivery Target","or it's free"]].map(([v,l,s]) => (
              <div key={l}>
                <div className="font-serif font-black text-4xl text-[#f97316] mb-1">{v}</div>
                <div className="font-bold text-white text-sm mb-1">{l}</div>
                <div className="text-xs text-gray-500">{s}</div>
              </div>
            ))}
          </div>
        </div>

        <h2 className="font-serif text-4xl text-gray-900 text-center mb-10">Meet the <span className="text-[#f97316]">Team</span></h2>
        <div className="grid md:grid-cols-4 gap-6">
          {[["Ganapathi Raman","Founder & CEO","GR","Started GamapaFoods with ₹50,000 and a dream"],["Lakshmi Devi","Head Chef","LD","25 years cooking authentic South Indian cuisine"],["Suresh Kumar","Operations","SK","Ensures every order reaches you in 30 minutes"],["Priya Nair","Customer Success","PN","Personally responds to every review and complaint"]].map(([n,r,a,bio]) => (
            <div key={n} className="bg-white rounded-3xl p-6 text-center border border-gray-100 shadow-sm card-hover">
              <div className="w-16 h-16 bg-gradient-to-br from-[#f97316] to-red-500 rounded-2xl flex items-center justify-center text-white font-black text-lg mx-auto mb-4 shadow-lg shadow-orange-200">{a}</div>
              <div className="font-bold text-gray-900 mb-0.5">{n}</div>
              <div className="text-xs font-bold text-[#f97316] mb-3">{r}</div>
              <p className="text-xs text-gray-400 leading-relaxed">{bio}</p>
            </div>
          ))}
        </div>
      </section>
       <Footer />
    </div>
  );
  
}
